export const CHILDREN_FREE_OFFER_PROMOTION_TYPE = 'CHILDREN_FREE_OFFER';

export const isChildrenFreeConfig = (config: MealPlanType): boolean =>
  config.promotions?.some((promotion) => promotion.type === CHILDREN_FREE_OFFER_PROMOTION_TYPE) ?? false;

export const hasChildrenFreeOffer = (configurations: readonly MealPlanType[]): boolean =>
  configurations.some(isChildrenFreeConfig);

export const getChildrenFreeDescription = (configurations: readonly MealPlanType[]): string | undefined =>
  configurations
    .map(
      (config) =>
        config.promotions?.find((promotion) => promotion.type === CHILDREN_FREE_OFFER_PROMOTION_TYPE)?.description
    )
    .find((description) => !!description);
